import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=121fa5c8&"
import script from "./Advice.vue?vue&type=script&lang=ts&"
export * from "./Advice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports